import React from "react";
import {Alert} from "@material-ui/lab";

export const Error = (props) => {

    const {errorMessage} = props;

    return (
        <>
            <Alert severity="error">
                <div>
                    Oops! Une erreur est survenue.
                </div>
                {errorMessage !== undefined &&
                    <div>
                        {errorMessage}
                    </div>
                }
            </Alert>
        </>
    );

}